<template>
	<div class="configurator cell">
		<div class="configurator__container">
			<uploader v-if="uploaderPosition.before"/>
			<product v-if="hasMultipleProducts"/>
			<format v-if="check.hasSelectedProduct"/>
			<page-step v-if="showPageCount"/>
			<template v-if="check.hasSelectedFormat && check.hasSelectedProduct && isOptionsRenderable">
				<option-groups
					v-for="optionGroup in optionGroups"
					:option-group="optionGroup"
					:key="optionGroup.id"/>
			</template>
			<configurator-overview v-if="showOverview"/>
			<uploader v-if="uploaderPosition.after && currentStep !== 'configurator-overview'"/>
		</div>
		<modal
			button-style="none"
			modal-style="styled"
			:open="openModal"
			title="Configureer uw product opnieuw">
			<p>
				<template v-if="getConfiguratorData.hasFormatMatches">Het door u <template v-if="uploadsAreComplete">geüploade bestand</template><template v-else>gekozen formaat</template> is mogelijk bij meerdere formaten. </template>
				<template v-else>Het door u <template v-if="uploadsAreComplete">geüploade bestand</template><template v-else>gekozen formaat</template> komt niet overeen met uw eerder gekozen formaat. </template>
				Selecteer daarom opnieuw uw opties.
			</p>
		</modal>
	</div>
</template>

<script>
import product from "@/components/product/product";
import format from "@/components/format/format";
import optionGroups from "@/components/option/option-groups";
import configuratorOverview from "@/components/overview/configurator-overview";
import modal from "@/components/element/modal";
import uploader from "@/components/uploader/uploader";
import { EventBus } from "@/store/index.js";
import PageStep from "./optional/page-step.vue";

export default {
	name: "Configurator",
	components: { PageStep, product, format, optionGroups, configuratorOverview, uploader, modal },
	data () {
		return {
			hasMultipleProducts: this.$store.state.configuratorData.hasMultipleProducts,
			openModal: false
		};
	},
	computed: {
		check () {
			return this.$store.getters.checkData;
		},
		printSidesCountChoice () {
			return this.$store.getters.isPrintSidesCountChoice;
		},
		optionGroups () {
			const optionGroups = this.$store.getters.getSelectedFormat.productOptionGroups;
			// Sort by index first, then alphabetically by name as tiebreaker
			return optionGroups.sort((a, b) => {
				if (a.index !== b.index) {
					return a.index - b.index;
				}
				return a.name.localeCompare(b.name);
			});
		},
		configuratorType () {
			return this.$store.getters.getConfiguratorType;
		},
		isOptionsRenderable () {
			return this.$store.getters.isOptionsRenderable;
		},
		showOverview () {
			return this.check.hasSelectedFormat
				&& this.check.hasSelectedProduct
				&& this.check.hasSelectedOptions
				&& this.$store.getters.isConfiguratorDataValid;
		},
		uploaderPosition () {
			return this.$store.getters.getUploaderPosition;
		},
		getConfiguratorData () {
			return this.$store.getters.getConfiguratorData;
		},
		uploadsAreComplete () {
			return this.$store.getters.uploadsAreComplete;
		},
		currentStep () {
			return this.$store.getters.getCurrentStep.data.name;
		},
		showPageCount () {
			const configHasUploadedFile = this.$store.state.baseProps.isConfiguration
				&& this.$store.state.config.configurationSettings.fileIsUploaded;

			return this.check.hasSelectedFormat
				&& this.getConfiguratorData.hasMultiplePages
				&& !this.uploadsAreComplete
				&& !this.printSidesCountChoice
				&& !this.$store.getters.getSelectedFormat.hidePageCount
				&& !configHasUploadedFile
				&& !this.$store.getters.hasConfiguratorPageCountOptions;
		}
	},
	mounted () {
		EventBus.$on("scrollToStep", () => {
			setTimeout(function () {
				let item = document.querySelector(".configurator-step--active");

				function offset (el) {
					const rect = el.getBoundingClientRect();
					const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
					const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
					return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
				}

				function scrollToItem (elem) {
					let topOfElement = offset(elem).top;

					window.scroll({
						"behavior": "smooth",
						"top": topOfElement - 130
					});
				}

				if (item) {
					scrollToItem(item);
				}
			}, 10);
		});

		EventBus.$on("selectedFormatDoesNotMatch", () => {
			this.openModal = false;
			setTimeout(function () {
				this.openModal = true;
			}.bind(this), 100);
		});
	}
};
</script>

<style lang="scss">
	.configurator {
		flex: 1 0 0;
	}

	.configurator__container {
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/configurator.vue